module.exports = function(element) {
  function searchBlock(el) {
    var form     = $(el)
    var node     = form.find('input');

    require('easy-autocomplete');

    var options = {
        url: function(phrase) {
            return "/moderator/suggest/tag/";
        },

        getValue: function(element) {
            return element;
        },

        ajaxSettings: {
            dataType: "json",
            method: "GET",
            data: {
              dataType: "json"
            }
        },

        list: {
            onChooseEvent: function() {
                form.submit();
            }
        },

        preparePostData: function(data) {
          data.term = node.val();
          return data;
        },

        requestDelay: 400
    };

    node.easyAutocomplete(options);
  }

  if (!element) {
    throw new Error('Element undefined');
  }

  searchBlock(element);
};